import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useAtom } from "jotai";
import { FC, useState } from "react";
import { modalConfirmSend, selectedDocumentsAtom } from "../../../atoms/atom";
import { DocumentsService } from "../../../services/DocumentService";
import { useAlert } from "../../contextProviders/AlertProvider";

const ConfirmSendModal: FC = () => {
	const [selectedDocuments] = useAtom(selectedDocumentsAtom);
	const [open, setOpen] = useAtom(modalConfirmSend);
	const [loading, setLoading] = useState(false);
	const { showAlert, showError } = useAlert();

	return (
		<Dialog
			open={open}
			onClose={() => setOpen(false)}
			id='modal-confirm-send'
		>
			<DialogTitle>Confirmar envio</DialogTitle>
			<DialogContent id="modal-forms-content">
				<Typography>
					Você confirma o envio dos documentos selecionados?
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button id="confirm-close-button" onClick={() => setOpen(false)}>
					Cancelar
				</Button>
				<Button
					id="confirm-button"
					color="success"
					onClick={() => save()}
				>
					{loading
						? <CircularProgress sx={{color: "#48a7dbff"}} size={'20px'}/>
						: "Enviar"
					}
				</Button>
			</DialogActions>
		</Dialog>
	);

	async function save() {
		setLoading(true);
		try {
			const response = await new DocumentsService().confirmSendDocuments(selectedDocuments);
			if (response.status === 200) {
				showAlert('Documentos enviados com sucesso', "success");
				setOpen(false);
			}
		} catch (error) {
			showError();
		} finally {
			setLoading(false);
		}
	}
}

export default ConfirmSendModal;